export default "__VITE_ASSET__hvdLwgXk__";